import { cn } from '../../../ui/cn';
import { copy } from '../copy';
import { FOCUS } from '../styles';

/** The amber main action (design.md: one per screen). Its own 44px+ button, never the whole tile. */
export function PlusOneButton({
  onPress,
  size = 'lg',
}: {
  onPress: () => void;
  size?: 'lg' | 'sm';
}) {
  return (
    <button
      type="button"
      aria-label={copy.logOne}
      onClick={onPress}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-accent font-mono font-medium text-on-accent transition-transform duration-100 active:scale-[0.98] motion-reduce:transition-none motion-reduce:active:scale-100',
        size === 'lg' ? 'h-16 min-w-20 px-6 text-2xl' : 'h-11 w-11 text-base',
        FOCUS,
      )}
    >
      +1
    </button>
  );
}
